<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <!-- Header -->
    <div
      :class="[
        theme.isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
        'border-b px-6 py-4 shadow-sm-custom sticky top-0 z-10'
      ]"
      style="box-shadow: var(--shadow-sm)"
    >
      <div class="max-w-[1600px] mx-auto">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <button
              class="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-all duration-200"
              @click="goBack"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 19l-7-7m0 0l7-7m-7 7h18"
                />
              </svg>
            </button>
            <div>
              <h1
                :class="[
                  theme.isDark.value ? 'text-gray-100' : 'text-gray-900',
                  'text-2xl font-bold'
                ]"
              >
                Create New Report
              </h1>
              <p :class="[theme.isDark.value ? 'text-gray-400' : 'text-gray-600', 'mt-1 text-sm']">
                Configure HTTP source, template transform, and Slack destination
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="max-w-[1600px] mx-auto p-6">
      <ReportForm
        mode="create"
        @saved="handleSaved"
        @cancel="goBack"
      />
    </div>

    <!-- Toast Notification -->
    <Toast
      v-model:show="toast.show"
      :message="toast.message"
      :type="toast.type"
      :duration="4000"
    />
  </div>
</template>

<script setup lang="ts">
import { reactive, inject } from 'vue'
import { useRouter } from 'vue-router'
import { useTheme } from '../../utils/useTheme'
import ReportForm from './components/ReportForm.vue'
import Toast from '../../components/base/common/Toast.vue'

const theme = inject('theme', useTheme())
const router = useRouter()

// Toast
const toast = reactive({
  show: false,
  message: '',
  type: 'success' as 'success' | 'error'
})

const showToast = (message: string, type: 'success' | 'error') => {
  toast.message = message
  toast.type = type
  toast.show = true
}

const goBack = () => {
  router.push('/platform-report')
}

const handleSaved = () => {
  showToast('Report created successfully', 'success')
  setTimeout(() => {
    router.push('/platform-report')
  }, 1000)
}
</script>
